<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-size:16px;color:#4a4b4e;">{{ $t('lang.ConfigSetting.DeviceSelection') }}</span>
      <!-- <div style="margin-top: 10px">
                  <span style="font-size:14px;color:rgb(216, 131, 131);">({{ $t('lang.ConfigSetting.deviceSelectTips')
                  }})</span>
                </div> -->
    </div>
    <div class="treegroupinglist">
      <el-input size="mini" class="Seek-Input" v-model="searchSN" :placeholder="$t('lang.ConfigSetting.SNSearch')"
        clearable></el-input>
      <div class="groupTree infinite-list" :infinite-scroll-disabled="deviceDisabled" :infinite-scroll-immediate="false"
        v-infinite-scroll="loadDevice">
        <el-tree class="filter-tree" :data="devicelistCopy" :props="deviceProps" @node-click="GetdevicelistDidAndSn"
          :highlight-current="true">
          <div slot-scope="{ node, data }">
            <span>{{ data.deviceSn + ` (${data.deviceName ? data.deviceName : 'N/A'})` }}</span>
            <el-tag :type="data.deviceIsConnected == 3 ? 'success' : 'danger'" style="margin-left: 10px;" size="mini">{{
              data.deviceIsConnected
                == 3 ? $t('lang.ConfigSetting.online') : $t('lang.ConfigSetting.offline') }}</el-tag>
          </div>
        </el-tree>
      </div>
    </div>
  </el-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { getGroupList, listConfig, GroupDevices, getAddLevel3Group, getGroupListPage } from "@/api/configurationlist";
export default {
  name: "device",
  props: ['gid'],
  data() {
    return {
      searchSN: '',
      deviceDisabled: true,
      devicelistCopy: [],
      deviceProps: {
        label: "label"
      },
      deviceParams: {
        limit: 200,
        offset: 1
      },
      devicelist: [],
      deviceMax: 1,
      oldGid: undefined
    };
  },
  methods: {
    GetdevicelistDidAndSn(data) {
      this.$emit('GetdevicelistDidAndSn', data)
    },
    loadDevice() {
      this.deviceParams.offset += 1
      this.getData()
    },
    getData() {
      GroupDevices(this.gid, 1, this.deviceParams.limit, this.deviceParams.offset, this.searchSN).then((res) => {
        if (this.searchSN !== '') {
          this.devicelist = []
        }
        this.devicelist = [...this.devicelist, ...res.data.data.list]
        this.devicelistCopy = this.devicelist.sort((a, b) => a.deviceIsConnected - b.deviceIsConnected)
        this.deviceMax = Math.ceil(res.data.data.total / this.deviceParams.limit)
        if (this.deviceMax > this.deviceParams.offset) {
          this.deviceDisabled = false
        } else {
          this.deviceDisabled = true
        }
      })
    }
  },
  watch: {
    searchSN(val) {
      this.deviceParams.offset = 1
      this.getData()
    },
    // devicelist(val) {
    //   if (Array.isArray(val) && val.length) {
    //     this.devicelistCopy = [...this.devicelistCopy, ...cloneDeep(val)]
    //     this.deviceDisabled = false
    //   }
    // },
    gid(val) {
      this.deviceParams.offset = 1
      this.searchSN = ""
      if (this.oldGid != val) {
        this.devicelist = []
      }
      this.oldGid = val
      if (val !== undefined) {
        this.getData()
      } else {
        this.devicelistCopy = []
        this.deviceDisabled = true
      }
    }
  }
};
</script>
<style scoped>
.treegroupinglist {
  width: 100%;
  height: 30vh;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
}

.groupTree {
  overflow: scroll;
  height: 100%;
}
</style>